import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { isRTL } from '../config';
import { Component } from '../component';
import { getLocale } from '../locale';
import { compose } from '../utils/func';
import { getDirectionClass } from '../utils/classname';
import { tableClass } from './styles';
import fixedAuto from './fixedAuto';
import Datum from '../Datum';
import Spin from '../Spin';
import resizableHOC from './resizable';
import { consumer as hideableConsumer } from '../hoc/hidable';
import SeperateTable from './SeperateTable';
import SimpleTable from './SimpleTable';
import { ROW_HEIGHT_UPDATE_EVENT } from './Tr';
import { RENDER_COL_GROUP_EVENT } from './Tbody';
import select from './select';
var ResizeSeperateTable = resizableHOC(SeperateTable);
var ResizeSimpleTable = resizableHOC(SimpleTable);

var RadioWrapper = function RadioWrapper(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Origin, Object.assign({}, props, {
        distinct: true,
        limit: props.radio ? 1 : 0
      }))
    );
  };
};

var DefaultProps = {
  hover: true,
  rowsInView: 20,
  verticalAlign: 'top',
  columns: [],
  size: 'default'
};

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper2(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.table = void 0;
    _this.visibleObserver = void 0;
    _this.state = {
      scrollLeft: 0,
      scrollRight: 0,
      inView: false
    };
    _this.bindTable = _this.bindTable.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.sticky && this.table && window.IntersectionObserver) {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];

          _this2.setState({
            inView: entry.intersectionRatio > 0
          });
        });
        observer.observe(this.table);
        this.visibleObserver = observer;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      var _this$props = this.props,
          datum = _this$props.datum,
          treeCheckAll = _this$props.treeCheckAll;
      datum.dispatch(ROW_HEIGHT_UPDATE_EVENT);
      datum.dispatch(RENDER_COL_GROUP_EVENT);

      if (treeCheckAll && this.props.data !== preProps.data) {
        datum.cleanDataCache();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.visibleObserver) {
        this.visibleObserver.disconnect();
        this.visibleObserver = null;
      }
    }
  }, {
    key: "getRowsInView",
    value: function getRowsInView() {
      var _this$props2 = this.props,
          _this$props2$rowsInVi = _this$props2.rowsInView,
          rowsInView = _this$props2$rowsInVi === void 0 ? DefaultProps.rowsInView : _this$props2$rowsInVi,
          data = _this$props2.data,
          fixed = _this$props2.fixed;
      var dataLength = data.length;
      if (rowsInView <= 0 || rowsInView > dataLength || fixed === 'x') return dataLength;
      return parseInt(String(rowsInView), 10);
    }
  }, {
    key: "getShouldSticky",
    value: function getShouldSticky() {
      return this.state.inView && this.props.sticky;
    }
  }, {
    key: "bindTable",
    value: function bindTable(el) {
      var bindWrapper = this.props.bindWrapper;
      this.table = el;
      if (el && bindWrapper) bindWrapper(el);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          striped = _this$props3.striped,
          bordered = _this$props3.bordered,
          size = _this$props3.size,
          hover = _this$props3.hover,
          height = _this$props3.height,
          columns = _this$props3.columns,
          children = _this$props3.children,
          empty = _this$props3.empty,
          data = _this$props3.data,
          style = _this$props3.style,
          fixed = _this$props3.fixed,
          width = _this$props3.width,
          loading = _this$props3.loading,
          verticalAlign = _this$props3.verticalAlign,
          columnResizable = _this$props3.columnResizable,
          events = _this$props3.events,
          others = _objectWithoutProperties(_this$props3, ["striped", "bordered", "size", "hover", "height", "columns", "children", "empty", "data", "style", "fixed", "width", "loading", "verticalAlign", "columnResizable", "events"]);

      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollRight = _this$state.scrollRight;
      var className = classnames(tableClass('_', size, hover && 'hover', bordered && 'bordered', fixed && 'fixed', scrollLeft > 0 && 'left-float', scrollRight < 0 && 'right-float', "vertical-".concat(verticalAlign), columnResizable && 'resize', this.getShouldSticky() && 'sticky', isRTL() && 'rtl'), this.props.className);

      var props = _objectSpread2(_objectSpread2({}, others), {}, {
        children: children,
        fixed: fixed,
        rowsInView: this.getRowsInView(),
        loading: loading,
        height: height,
        width: width,
        data: data,
        columns: columns,
        striped: striped,
        bordered: bordered,
        columnResizable: columnResizable
      });

      var isEmpty = (!data || data.length === 0) && !children;
      var useSeparate = fixed && !isEmpty;
      var ResizeSepTable = columnResizable ? ResizeSeperateTable : SeperateTable;
      var ResizeSimTable = columnResizable ? ResizeSimpleTable : SimpleTable;
      var RenderTable = useSeparate ? ResizeSepTable : ResizeSimTable;
      var newStyle = Object.assign({}, style);
      if (height) newStyle.height = height;
      if (useSeparate && !newStyle.height) newStyle.height = '100%';
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          ref: this.bindTable,
          style: newStyle
        }, events),
        /*#__PURE__*/
        React.createElement(RenderTable, Object.assign({}, props, {
          bordered: bordered,
          sticky: this.getShouldSticky(),
          inView: this.state.inView
        })), loading &&
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass('loading')
        }, typeof loading === 'boolean' ?
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 40
        }) : loading), isEmpty &&
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass(getDirectionClass('empty')),
          style: {
            visibility: loading ? 'hidden' : 'visible'
          }
        },
        /*#__PURE__*/
        React.createElement("span", null, empty || getLocale('noData'))))
      );
    }
  }]);

  return Table;
}(Component);

Table.defaultProps = DefaultProps;
var bindKeys = ['disabled', 'format', 'prediction', 'limit', 'distinct'];
export default compose(RadioWrapper, Datum.hoc({
  bindProps: bindKeys,
  ignoreUndefined: true,
  setValueType: null,
  pure: false
}), fixedAuto, hideableConsumer, select)(Table);